import React from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import DragDropContextComponent from '../DragAndDrop/DragDropContext';

const Tabs = ({
  tabsData,
  onClick,
  activeTab,
  isDraggable = false,
  isDragDisabled = false,
  onDragEnd = () => { },
}) => {
  const draggableItems = tabsData.map((tab, index) => {
    return (
      <Tab
        key={tab.title}
        title={tab.title}
        onClick={(e) => onClick(e, tab.title)}
        isActive={tab.title === activeTab}
        length={tab.length}
        isDraggable={isDraggable}
        isDragDisabled={isDragDisabled} // for DnD tabs if new position will be saved immediately after drag and drop
        draggableIndex={index}
      />
    );
  });
  return (
    <>
      {isDraggable ? (
        <DragDropContextComponent
          draggableItems={draggableItems}
          onDragEnd={(result) => onDragEnd(result)}
          direction="horizontal"
          className="flex gap-9.5"
        />
      ) : (
        <div className="flex gap-9.5">
          {draggableItems}
        </div>
      )}
    </>

  );
};

Tabs.propTypes = {
  tabsData: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  isDraggable: PropTypes.bool,
  isDragDisabled: PropTypes.bool,
  onDragEnd: PropTypes.func,
};

export default Tabs;
